(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawvelin-collection-browser"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pawvelin-collection-browser')) {
    customElements.define('pawvelin-collection-browser', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        const tabs = [...this.querySelectorAll('[role=tab]')];
        const panels = [...this.querySelectorAll('[role=tabpanel]')];
        let selected = 0;
        const select = (index, focus = false) => {
          if (!tabs.length) return;
          selected = (index + tabs.length) % tabs.length;
          tabs.forEach((tab,i) => {
            tab.setAttribute('aria-selected',String(i===selected));
            tab.tabIndex = i===selected ? 0 : -1;
            panels[i].hidden = i!==selected;
          });
          this.querySelector('.paw-browser__status').textContent = `${selected+1} / ${tabs.length} · ${tabs[selected].textContent.trim()}`;
          if (focus) tabs[selected].focus();
        };
        tabs.forEach((tab,index) => {
          tab.addEventListener('click',()=>select(index),options);
          tab.addEventListener('keydown',event=>{
            if (['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) {
              event.preventDefault();
              select(event.key==='Home'?0:event.key==='End'?tabs.length-1:selected+(event.key==='ArrowRight'?1:-1),true);
            }
          },options);
        });
        this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>select(selected+Number(button.dataset.direction)),options));
        this.sectionSelect = event => {
          const index = tabs.findIndex(tab=>tab.contains(event.target));
          if (index>=0) select(index);
        };
        this.addEventListener('shopify:block:select',this.sectionSelect,options);
        select(0);
      }
      disconnectedCallback(){this.controller?.abort();this.controller=null;}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawvelin-expanding-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pawvelin-panels')) {
    customElements.define('pawvelin-panels', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.panels = [...this.querySelectorAll('.paw-panel')];
        this.coarse = window.matchMedia('(hover: none), (pointer: coarse)');
        this.small = window.matchMedia('(max-width: 989px)');
        this.activate = (panel) => {
          this.panels.forEach(item => {
            const active = item === panel;
            item.classList.toggle('is-active', active);
            item.querySelector('.paw-panel__toggle').setAttribute('aria-expanded', String(active));
            item.querySelector('.paw-panel__link').tabIndex = active ? 0 : -1;
          });
        };
        this.panels.forEach(panel => {
          panel.addEventListener('pointerenter', () => {
            if (!this.coarse.matches) this.activate(panel);
          }, options);
          panel.addEventListener('focusin', () => this.activate(panel), options);
          panel.querySelector('.paw-panel__toggle').addEventListener('click', () => this.activate(panel), options);
        });
        this.querySelector('.paw-hero__panels').addEventListener('pointerleave', () => {
          if (!this.coarse.matches && !this.contains(document.activeElement)) this.activate(null);
        }, options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget) && !this.coarse.matches) this.activate(null);
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            document.activeElement.blur();
            this.activate(this.small.matches ? this.panels[0] : null);
          }
          if (['ArrowRight','ArrowDown','ArrowLeft','ArrowUp'].includes(event.key) && event.target.matches('.paw-panel__toggle')) {
            event.preventDefault();
            const index = this.panels.indexOf(event.target.closest('.paw-panel'));
            const direction = ['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1;
            this.panels[(index + direction + this.panels.length) % this.panels.length].querySelector('.paw-panel__toggle').focus();
          }
        }, options);
        const reset = () => this.activate(this.small.matches || this.coarse.matches ? this.panels[0] : null);
        this.small.addEventListener('change', reset, options);
        this.coarse.addEventListener('change', reset, options);
        this.activate(this.small.matches || this.coarse.matches ? this.panels[0] : null);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawvelin-harness-variants"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pawvelin-harness-showcase')){
  customElements.define('pawvelin-harness-showcase',class extends HTMLElement{
    connectedCallback(){
      if(this.boundClick)return;
      this.boundClick=(event)=>{
        const card=event.target.closest('a[data-variant-id]');
        if(!card||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        event.preventDefault();
        const url=new URL(window.location.href);
        url.searchParams.set('variant',card.dataset.variantId);
        url.hash='';
        window.location.assign(url.href);
      };
      this.addEventListener('click',this.boundClick);
    }
    disconnectedCallback(){this.removeEventListener('click',this.boundClick);this.boundClick=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawvelin-leash-variants"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pawvelin-variant-showcase')){
  customElements.define('pawvelin-variant-showcase',class extends HTMLElement{
    connectedCallback(){
      if(this.boundClick)return;
      this.boundClick=(event)=>{
        const card=event.target.closest('a[data-variant-id]');
        if(!card||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        event.preventDefault();
        const url=new URL(window.location.href);
        url.searchParams.set('variant',card.dataset.variantId);
        url.hash='';
        window.location.assign(url.href);
      };
      this.addEventListener('click',this.boundClick);
    }
    disconnectedCallback(){this.removeEventListener('click',this.boundClick);this.boundClick=null;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
